<template>
	<v-container class="pa-1">
		<v-row no-gutters class="rounded-md pa-2">
			<v-col cols='3' id="sortition-information">
				<slot name="name" :sortition="result.sortition">
					<h4>{{ result.sortition.name }}</h4>
				</slot>
				<h4>
					{{ result.date }}
				</h4>
			</v-col>
			<v-col>
				<v-row no-gutters justify="center">
					<v-col cols="auto">
						<v-row v-if='result.first || result.second || result.third' justify='center' no-gutters>
							<v-col cols='auto' class='d-flex align-center'>
								<h4 class="mx-1">
									1st
								</h4>
								<digit-image-display display-as-one class='d-flex' :digit='result.first'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
							<v-col cols='auto' class='d-flex mx-2 align-center'>
								<h4 class="mx-1">
									2nd
								</h4>
								<digit-image-display display-as-one class='d-flex' :digit='result.second'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
							<v-col cols='auto' class='mx-1 d-flex align-center'>
								<h4 class="mx-1">
									3rd
								</h4>
								<digit-image-display display-as-one class='d-flex' :digit='result.third'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
						<v-row v-if='result.cashThree' no-gutters>
							<v-col cols='auto' class="d-flex align-center">
								<span class='font-weight-bold text-uppercase text-h6'>PICK 3</span>
								<digit-image-display class='d-flex ml-3' :digit='result.cashThree' :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
						<v-row v-if='result.pickFour' no-gutters>
							<v-col cols='auto' class="d-flex align-center">
								<span class='font-weight-bold text-uppercase text-h6'>PICK 4</span>
								<digit-image-display class='d-flex ml-3' horizontal :digit='result.pickFour' :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
						<v-row v-if='result.pickFive' no-gutters>
							<v-col cols='auto' class="d-flex align-center">
								<span class='font-weight-bold text-uppercase text-h6'>PICK 5</span>
								<digit-image-display class='d-flex ml-3' horizontal :digit='result.pickFive' :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DigitImageDisplay from '@/homepage/components/DigitImageDisplay.vue';
import ResultDisplay from '@homepage/components/ResultDisplay.js';

export default {
	name: 'CaribbeanPickComplexResultDisplay',
	extends: ResultDisplay,
	components: {
		DigitImageDisplay
	}
};
</script>

<style scoped>
#sortition-information {
	border-right: 1px solid white;
}
</style>
